import OtherHome from '@/layouts/OtherHome.vue'
import store from '@/store'

const type = 'other'

export const otherRoute = {
  path: '/other',
  name: 'other-home',
  component: OtherHome,
  meta: {
    resource: [{ other: 'all' }, { admin: 'all' }, { ceo: 'all' }],
    type,
  },
  children: [
    {
      path: 'dashboard',
      name: `${type}/dashboard`,
      component: () => import(/* webpackChunkName: "Dashboard" */ '../../views/OtherDashboard.vue'),
    },
    {
      path: 'trcm',
      name: `${type}/trcm`,
      component: () => import(/* webpackChunkName: "TRCMView" */ '../../views/TRCMView.vue'),
    },
    {
      path: 'calendar',
      name: `${type}/calendar`,
      component: () => import(/* webpackChunkName: "Calendar" */ '../../views/Calendar.vue'),
    },
    {
      path: 'event/:id?',
      name: `${type}/event-edit`,
      component: () => import('../../views/EventForm.vue'),
      meta: { requiresAuth: true },
      props: (route) => ({
        selectedEventId: route.params.id,
        startAt: route.query.startAt,
        endAt: route.query.endAt,
        memberId: route.query.memberId,
      }),
    },
    {
      path: 'event/new',
      name: `${type}/event-new`,
      component: () => import('../../views/EventForm.vue'),
      meta: { requiresAuth: true },
      props: (route) => ({
        startAt: route.query.startAt,
        endAt: route.query.endAt,
        memberId: route.query.memberId,
      }),
    },
    {
      path: 'document-export/:id',
      name: `${type}/document-export`,
      component: () =>
        import(
          /* webpackChunkName: "DocumentExport" */ '../../components/AssetsConsolidations/Export/DocumentExport.vue'
        ),
    },

    {
      path: 'blueprint-report/:id',
      name: `${type}/blueprint-report`,
      component: () => import(/* webpackChunkName: "BlueprintReport" */ '../../components/Report/BlueprintReport.vue'),
    },

    {
      path: 'rebalance',
      name: `${type}/rebalance`,
      component: () => import(/* webpackChunkName: "ListOfRebalance" */ '../../views/ListOfRebalance.vue'),
      children: [
        {
          path: 'trade-requests',
          name: `${type}/trade-requests`,
          component: () =>
            import(/* webpackChunkName: "submitted" */ '../../components/RebalanceRequest/List/TradeRequests.vue'),
        },
        {
          path: 'trade-generated',
          name: `${type}/trade-generated`,
          component: () =>
            import(/* webpackChunkName: "generated" */ '../../components/RebalanceRequest/List/GeneratedFiles.vue'),
        },
        {
          path: 'trade-downloaded',
          name: `${type}/trade-downloaded`,
          component: () =>
            import(/* webpackChunkName: "history" */ '../../components/RebalanceRequest/List/DownloadedFiles.vue'),
        },
        {
          path: 'form/:id?',
          name: `${type}/rebalance-form`,
          component: () =>
            import(/* webpackChunkName: "RebalanceRequest" */ '../../components/RebalanceRequest/RebalanceRequest.vue'),
        },
      ],
    },

    {
      path: 'client-report/:id',
      name: `${type}/clientreport`,
      component: () => import(/* webpackChunkName: "ClientReport" */ '../../views/ClientReport.vue'),
      children: [
        {
          path: 'client-reports-list',
          name: `${type}/client-reports-list`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ClientReportList.vue'),
        },
        {
          path: 'contract-info/:contract_id?',
          name: `${type}/contract-info`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ContractDetails.vue'),
        },
      ],
    },

    {
      path: 'task-queue/:p?',
      name: `${type}/task-queue`,
      component: () => import(/* webpackChunkName: "ClientReport" */ '../../views/TaskQueue.vue'),
      children: [
        {
          path: 'tasks',
          name: `${type}/tasks`,
          component: () => import(/* webpackChunkName: "ClientReport" */ '../../components/Tasks/Task.vue'),
        },
        {
          path: 'queues',
          name: `${type}/queues`,
          component: () => import(/* webpackChunkName: "ClientReport" */ '../../components/Queues/ViewAllQueues.vue'),
        },
      ],
    },
    {
      path: 'task/new',
      name: `${type}/task-new`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'task/:taskId/:parentId?/edit',
      name: `${type}/task-edit`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'interaction/new',
      name: `${type}/interaction-new`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
    },

    {
      path: 'interaction/:interactionId/edit',
      name: `${type}/interaction-edit`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
      props: true,
    },

    {
      path: 'interaction/:interactionId',
      name: `${type}/interaction-details`,
      component: () => import(/* webpackChunkName: "InteractionDetails" */ '../../views/InteractionDetails.vue'),
      props: true,
    },

    {
      path: 'all-queues/:qid',
      name: `${type}/all-queues`,
      component: () => import(/* webpackChunkName: "AllQueues" */ '../../components/Queues/ViewAllQueues.vue'),
    },
    {
      path: 'create-account',
      name: `${type}/create-account`,
      component: () => import(/* webpackChunkName: "AllQueues" */ '../../components/Customers/CreateAccount.vue'),
    },
    {
      path: 'activity',
      name: 'activity',
      component: () => import(/* webpackChunkName: "Activity" */ '../../views/Activity.vue'),
    },

    {
      path: 'pipeline/:p?',
      name: `${type}/pipeline`,
      component: () => import(/* webpackChunkName: "PipeLine" */ '../../views/PipeLine.vue'),
    },

    {
      path: 'logs',
      name: `${type}/logs`,
      component: () => import(/* webpackChunkName: "Logs" */ '../../views/Logs.vue'),
    },
    {
      path: 'error',
      name: `${type}/error`,
      component: () => import(/* webpackChunkName: "Error" */ '../../views/ErrorPage.vue'),
    },

    {
      path: 'leads',
      name: `${type}/leads`,
      component: () => import(/* webpackChunkName: "Leads" */ '../../views/Leads.vue'),
      children: [
        {
          path: 'all-leads/:p?',
          name: `${type}/all-leads`,
          component: () => import(/* webpackChunkName: "LisAllLeads" */ '../../components/ListLeads/ListAllLeads.vue'),
        },
        {
          path: 'active-leads/:p?',
          name: `${type}/active-leads`,
          component: () =>
            import(/* webpackChunkName: "ListActiveLeads" */ '../../components/ListLeads/ListActiveLeads.vue'),
        },
        {
          path: 'deactivated-leads/:p?',
          name: `${type}/deactivated-leads`,
          component: () =>
            import(
              /* webpackChunkName: "ListDeactivatedLeads" */ '../../components/ListLeads/ListDeactivatedLeads.vue'
            ),
        },
      ],
    },

    {
      path: 'pre-leads',
      name: `${type}/pre-leads`,
      component: () => import(/* webpackChunkName: "Pre-Leads" */ '../../views/PreLeads.vue'),
      children: [
        {
          path: 'all-pre-leads/:p?',
          name: `${type}/all-pre-leads`,
          component: () =>
            import(/* webpackChunkName: "ListAllPreLeads" */ '../../components/ListPreLeads/ListAllPreLeads.vue'),
        },
      ],
    },

    {
      path: 'child-opportunity/:id?/:opportunityId?',
      name: `${type}/child-opportunity`,
      component: () => import(/* webpackChunkName: "Pre-Leads" */ '../../views/ChildOpportunities.vue'),
    },
    {
      path: 'opportunity/new/:id',
      name: `${type}/opportunity-new`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityForm" */ '../../components/MemberDetails/Opportunity/OpportunityForm.vue'
        ),
    },
    {
      path: 'opportunity/edit/:id/:opportunityId',
      name: `${type}/opportunity-edit`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityForm" */ '../../components/MemberDetails/Opportunity/OpportunityForm.vue'
        ),
    },
    {
      path: 'annuity-details/:contractId',
      name: `${type}/annuity-details`,
      component: () => import(/* webpackChunkName: "AnnuityForm" */ '../../components/Annuity/AnnuityForm.vue'),
    },

    {
      path: 'member/:id',
      name: `${type}/member`,
      component: () => import(/* webpackChunkName: "MemberDetails" */ '../../views/MemberDetails.vue'),
      children: [
        {
          path: 'member-details',
          name: `${type}/member-details`,
          component: () =>
            import(/* webpackChunkName: "MemberDetails" */ '../../components/MemberDetails/MemberDetails.vue'),
        },
        {
          path: 'annuity',
          name: `${type}/annuity`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
        },

        {
          path: 'annuity-index-details/:annuityId?',
          name: `${type}/annuity-index-details`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
        },
        {
          path: 'member-tasks/:p?',
          name: `${type}/member-tasks`,
          component: () =>
            import(/* webpackChunkName: "MemberAllTaskList" */ '../../components/Tasks/MemberAllTaskList.vue'),
        },
        {
          path: 'meeting-notes/:p?',
          name: `${type}/meeting-notes`,
          component: () =>
            import(/* webpackChunkName: "AllMeetingNotes" */ '../../components/MeetingNotes/AllMeetingNotes.vue'),
        },
        {
          path: 'meeting-note-new',
          name: `${type}/meeting-note-new`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteForm" */
              '@/components/MeetingNotes/MeetingNoteFormPage.vue'
            ),
        },
        {
          path: 'meeting-note-edit/:noteId',
          name: `${type}/meeting-note-edit`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteForm" */
              '@/components/MeetingNotes/MeetingNoteFormPage.vue'
            ),
          props: true,
        },
        {
          path: 'meeting-note-details/:noteId',
          name: `${type}/meeting-note-details`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteDetails" */
              '@/components/MeetingNotes/MeetingNoteDetailPage.vue'
            ),
          props: true,
        },
        {
          path: 'member-events/:p?',
          name: `${type}/member-events`,
          component: () =>
            import(/* webpackChunkName: "MemberAllEvent" */ '../../components/Calendar/MemberAllEvents.vue'),
        },
        {
          path: 'on-boarding/:on_boarding_id?',
          name: `${type}/on-boarding`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/OnBoarding/EditOnboarding.vue'),
        },
        {
          path: 'member-activities/:p?',
          name: `${type}/member-activities`,
          component: () =>
            import(/* webpackChunkName: "MemberAllTaskList" */ '../../components/ActivityDetails/AllActivity.vue'),
        },
        {
          path: 'manage-money-dashboard',
          name: `${type}/member-manage-money-dashboard`,
          component: () =>
            import(
              /* webpackChunkName: "ManageMoneyDashboard" */ '../../components/RevenueDashboard/ManageMoneyDashboard.vue'
            ),
        },
        {
          path: 'referral/new',
          name: `${type}/referral-new`,
          component: () => import(/* webpackChunkName: "ReferralForm" */ '../../components/Referral/ReferralForm.vue'),
        },
        {
          path: 'referral/edit/:referralId',
          name: `${type}/referral-edit`,
          component: () => import(/* webpackChunkName: "ReferralForm" */ '../../components/Referral/ReferralForm.vue'),
        },
        {
          path: 'gifts/new',
          name: `${type}/gift-new`,
          component: () => import('../../components/Gifts/GiftFormPage.vue'),
        },
        {
          path: 'gifts/:giftId/edit',
          name: `${type}/gift-edit`,
          component: () => import('../../components/Gifts/GiftFormPage.vue'),
        },
        {
          path: 'gifts/:giftId',
          name: `${type}/gift-details`,
          component: () => import('../../components/Gifts/GiftDetailsPage.vue'),
        },
        {
          path: 'contacts',
          name: `${type}/member-contacts`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContacts" */ '../../components/OpportunityContact/OpportunityContact.vue'
            ),
        },
        {
          path: 'contacts/create',
          name: `${type}/member-contact-create`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContactCreate" */ '../../components/MemberDetails/MemberContact/MemberContactCreate.vue'
            ),
        },
        {
          path: 'contacts/:contactId/edit',
          name: `${type}/member-contact-edit`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContactEdit" */ '../../components/MemberDetails/MemberContact/MemberContactEdit.vue'
            ),
        },
        {
          path: 'add-client-note',
          name: `${type}/add-client-note`,
          component: () =>
            import(/* webpackChunkName: "AddClientNote" */ '../../components/ClientNotes/AddClientNote.vue'),
        },
        {
          path: 'edit-client-note/:noteId',
          name: `${type}/edit-client-note`,
          component: () =>
            import(/* webpackChunkName: "EditClientNote" */ '../../components/ClientNotes/EditClientNote.vue'),
        },
      ],
    },

    {
      path: 'past-stress-test/:id',
      name: `${type}/past-stress-test`,
      component: () =>
        import(
          /* webpackChunkName: "PastStressTestResults" */ '../../components/MemberDetails/PastStressTestResults.vue'
        ),
    },

    {
      path: 'asset-allocation-details/:id',
      name: `${type}/asset-allocation-details`,
      component: () =>
        import(/* webpackChunkName: "AssetAllocation" */ '../../components/AssetAllocation/AssetAllocationDetails.vue'),
    },

    {
      path: 'asset-accounts/:id',
      name: `${type}/asset-accounts`,
      component: () =>
        import(/* webpackChunkName: "AssetAccounts" */ '../../components/AssetAccounts/AssetAccounts.vue'),
    },

    {
      path: 'opportunity-contact/:id',
      name: `${type}/opportunity-contact`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityContact" */ '../../components/OpportunityContact/OpportunityContact.vue'
        ),
    },

    {
      path: 'basic-information/:id',
      name: `basic-information`,
      component: () =>
        import(
          /* webpackChunkName: "MemberDetails" */ '../../components/MemberBasicInformation/MemberBasicInformation.vue'
        ),
    },
    {
      path: 'edit-member-basic-information/:id',
      name: `${type}/edit-member-basic-information`,
      component: () =>
        import(
          /* webpackChunkName: "MemberDetails" */ '../../components/MemberBasicInformation/EditMemberBasicInformation.vue'
        ),
    },
    {
      path: 'prospect-employment/:id',
      name: `${type}/prospect-employment`,
      component: () =>
        import(/* webpackChunkName: "ProspectEmployment" */ '../../components/EmploymentHistory/EmploymentHistory.vue'),
    },

    {
      path: 'new-prospect',
      name: `${type}/newprospect`,
      component: () => import(/* webpackChunkName: "NewProspect" */ '../../views/NewProspect.vue'),
      children: [
        {
          path: 'basic/:id?',
          name: `${type}/basic-information`,
          component: () =>
            import(/* webpackChunkName: "NewProspect" */ '../../components/NewProspect/AddProspectBasicInfo.vue'),
        },
        {
          path: 'assets/:id?',
          name: `${type}/assets-information`,
          component: () =>
            import(/* webpackChunkName: "NewProspect" */ '../../components/NewProspect/AddProspectAssetsIncome.vue'),
        },
        {
          path: 'monthly-expense/:id?',
          name: `${type}/monthly-expense`,
          component: () =>
            import(/* webpackChunkName: "NewProspect" */ '../../components/NewProspect/AddProspectExpense.vue'),
        },
        {
          path: 'assets-account/:id?',
          name: `${type}/assets-account`,
          component: () =>
            import(/* webpackChunkName: "NewProspect" */ '../../components/NewProspect/NewProspectAssetsAccounts.vue'),
        },
        {
          path: 'add-assets-consolidations/:id?',
          name: `${type}/add-assets-consolidations`,
          component: () =>
            import(
              /* webpackChunkName: "NewProspect" */ '../../components/NewProspect/AddAssetsConsolidations/AddAssetsConsolidations.vue'
            ),
        },
        {
          path: 'stress-test/:id?',
          name: `${type}/stresstest`,
          component: () =>
            import(
              /* webpackChunkName: "NewProspect" */ '../../components/NewProspect/StressTestResult/NewProspectPdf.vue'
            ),
        },
      ],
    },
    {
      path: 'contacts',
      name: `${type}/contacts`,
      component: () => import('../../components/GlobalContact/ContactsList.vue'),
    },
    {
      path: 'contacts/create',
      name: `${type}/contacts-create`,
      component: () => import('../../components/GlobalContact/ContactsCreate.vue'),
    },
    {
      path: 'contacts/:id/edit',
      name: `${type}/contacts-edit`,
      component: () => import('../../components/GlobalContact/ContactsEdit.vue'),
    },
    {
      path: 'export-report/:id',
      name: `${type}/export-report`,
      component: () =>
        import(
          /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ExportClientReports.vue'
        ),
      children: [
        {
          path: 'all',
          name: `${type}/all-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportAll.vue'
            ),
        },
        {
          path: 'pdf',
          name: `${type}/pdf-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportPdf.vue'
            ),
        },
        {
          path: 'excel',
          name: `${type}/excel-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportExcel.vue'
            ),
        },
      ],
    },

    {
      path: 'list-of-households/:AdvisorHouseholdsParam?',
      name: `${type}/list-of-households`,
      component: () => import(/* webpackChunkName: "ListOfHouseholds" */ '../../views/ListOfHouseholds.vue'),
      beforeEnter: (to, from, next) => {
        const permissionGroups = store.state.globalComponents?.permissions?.permissionGroups || {}
        const memberPermissions = permissionGroups.member || []
        const opportunityPermissions = permissionGroups.opportunity || []

        const hasMemberView = memberPermissions.some((p) => p.name === 'member.view')
        const hasOpportunityView = opportunityPermissions.some((p) => p.name === 'opportunity.view')

        if (hasMemberView || hasOpportunityView) {
          next()
        } else {
          next({ name: `${type}/dashboard` })
        }
      },
      children: [
        {
          path: 'all/:p?',
          name: `${type}/all`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListAll.vue'),
          beforeEnter: (to, from, next) => {
            const permissionGroups = store.state.globalComponents?.permissions?.permissionGroups || {}
            const memberPermissions = permissionGroups.member || []
            const hasMemberView = memberPermissions.some((p) => p.name === 'member.view')

            if (hasMemberView) {
              next()
            } else {
              // Redirect to opportunities if they have that permission instead
              next({ name: `${type}/opportunities` })
            }
          },
        },
        {
          path: 'opportunities/:p?',
          name: `${type}/opportunities`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListOpportunities.vue'
            ),
        },
        {
          path: 'prospects/:p?',
          name: `${type}/prospects`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProspects.vue'),
        },
        {
          path: 'clients/:p?',
          name: `${type}/clients`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListClients.vue'),
        },
        {
          path: 'business/:p?',
          name: `${type}/business`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListBusiness.vue'),
        },
        {
          path: 'professional-relationship/:p?',
          name: `${type}/professional-relationship`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProfessionalRelationship.vue'
            ),
        },
      ],
    },
    {
      path: 'revenue-dashboard',
      name: `${type}/revenue-dashboard`,
      component: () =>
        import(/* webpackChunkName: "RevenueDashboard" */ '../../components/RevenueDashboard/RevenueDashboard.vue'),
    },
    {
      path: 'dashboard-link/add',
      name: `${type}/dashboard-link-add`,
      component: () => import(/* webpackChunkName: "AddLink" */ '../../components/RevenueDashboard/AddLink.vue'),
    },
    {
      path: 'dashboard-link/:id/edit',
      name: `${type}/dashboard-link-edit`,
      component: () => import(/* webpackChunkName: "AddLink" */ '../../components/RevenueDashboard/AddLink.vue'),
    },
    {
      path: 'analytics-dashboard',
      name: `${type}/analytics-dashboard`,
      component: () =>
        import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/RevenueDashboard/AnalyticsDashboard.vue'),
    },
    {
      path: 'schwab/:p?',
      name: `schwab`,
      component: () =>
        import(/* webpackChunkName: "ListContent" */ '../../components/SchwabReport/SchwabDashboard.vue'),
    },
    {
      path: 'annuity/:p?',
      name: 'annuity',
      component: () => import(/* webpackChunkName: "Annuity" */ '../../components/Annuity/Annuity.vue'),
    },
    {
      path: 'profile/:memberId?/:accountId/:p?',
      name: `${type}/profile`,
      component: () =>
        import(/* webpackChunkName: "Transactions" */ '../../components/SchwabReport/Account/Profile.vue'),
    },
    {
      path: 'annuity-index/:id',
      name: 'annuity-index',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
    },
    {
      path: 'annuity-index-details/:id?',
      name: 'annuity-index-details',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
    },
    {
      path: 'meeting-note-print/:id',
      name: `${type}/meeting-note-print`,
      component: () =>
        import(
          /* webpackChunkName: "MeetingNotePrintPreview" */ '../../components/MeetingNotes/MeetingNotePrintPreview.vue'
        ),
    },
  ],
}
